/**
 * Checks if a digital fee should be applied for given publisher codes
 * @param {string | string[]} publisherCodes - Publisher code(s) to check
 * @returns {Promise<Array<{code: string, isApplied: boolean}>>}
 */
function queryDigitalDeliveryFeesApi(publisherCodes) {
  if (
    window.digital_product_config == undefined ||
    window.digital_product_config?.api_url == undefined ||
    window.digital_product_config?.store_number == undefined
  ) {
    throw Error("Digital fee config does not exist");
  }

  const api_url = window.digital_product_config.api_url;
  const store_number = window.digital_product_config.store_number;
  const queryValue =
    typeof publisherCodes === "string"
      ? publisherCodes
      : publisherCodes.reduce(
          (acc, value, currentIndex) =>
            acc.concat(`${currentIndex > 0 ? "|" : ""}${value}`),
          ""
        );

  if (queryValue != "") {
    return fetch(
      `${api_url}?storeNumber=${store_number}&downloadprovidercode=${queryValue}`
    )
      .then((res) => res.json())
      .then((data) => {
        return data.map((entry) => {
          return {
            code: entry.code,
            isApplied: entry.isApplied ?? false,
          };
        });
      })
      .catch((e) => console.log(e));
  } else {
    return Promise.resolve([]);
  }
}

// Digital fee tooltip visibility management
async function updateDigitalFeeTooltips() {
  const checkboxContainers = document.querySelectorAll(
    ".purchase-checkbox-container"
  );

  if (checkboxContainers.length === 0) {
    return;
  }

  const publisherCodesToCheck = [];
  const variantDataMap = new Map();
  checkboxContainers.forEach((container) => {
    const input = container.querySelector("input.purchase-checkbox");

    if (!input) return;

    const isDigital = input.dataset.isDigital === "true";
    const publisherCode = input.dataset.publisherCode;
    const variantId = input.dataset.variantId;

    if (
      isDigital &&
      publisherCode &&
      publisherCode !== "null" &&
      publisherCode.trim() !== ""
    ) {
      publisherCodesToCheck.push(publisherCode);
      variantDataMap.set(publisherCode, {
        variantId,
        publisherCode,
      });
    }
  });

  if (publisherCodesToCheck.length === 0) {
    return;
  }

  queryDigitalDeliveryFeesApi(publisherCodesToCheck).then((results) => {
    results.forEach((result) => {
      const isApplied = result.isApplied ?? false;
      if (isApplied) {
        const variantData = variantDataMap.get(result.code);
        if (variantData) {
          const tooltip = document.querySelector(
            `.notice-tooltip[data-variant-id="${variantData.variantId}"]`
          );
          if (tooltip) {
            tooltip.classList.remove("hidden");
          }
        }
      }
    });
  });
}

// Run tooltip update when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", updateDigitalFeeTooltips);
} else {
  updateDigitalFeeTooltips();
}

document.addEventListener("product-display:updated", () => {
  updateDigitalFeeTooltips();
});
